<template>
    <section class="m-filters">
        <div class="container">
            <div class="row">
                <search-filters :show-results-count="false"></search-filters>
            </div>
        </div>
    </section>
</template>

<script>
    import SearchFilters from '@/components/SiteSearch/search-filters'

    export default {
        components: {
            SearchFilters
        }
    }
</script>